export const createEventStreamListener = (props) => {
  const {
    eventPath, shouldStayAlive,
    dispatch = () => {},
    onError = () => {},
    retryCounts,
    retryLimit = 0
  } = props;

  let evtSource = new EventSource(eventPath, {headers: {"Content-type": "text/event-stream"}});

  evtSource.onopen = evt => {
    console.log("SSE Channel Connection Opened...");
  };

  evtSource.onerror = evt => {
    console.log("There was an error listening on the SSE Channel...");
    if (evtSource.readyState === EventSource.CLOSED && shouldStayAlive) {
      onError();
      if (retryLimit === 0 || retryCounts <= retryLimit)
        evtSource = createEventStreamListener({
          eventPath,
          shouldStayAlive,
          dispatch,
          onError,
          retryCounts: retryCounts + 1
        });
    }
  };

  evtSource.onmessage = evt => {
    console.log("Successfully listening OnMessage Channel...");
    const evtData = JSON.parse(evt.data);
    console.log("Dispatch EventStream", evtData);
    if (evtData.progress === 100) evtSource.close();
    dispatch(evtData);
  };

  return evtSource;
};
